import { Link, Navigate } from "react-router-dom";
import { useAffiliate } from "@/hooks/useAffiliate";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading, isAffiliate } = useAffiliate();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!loading && user !== undefined) {
      setTimedOut(false);
      return;
    }
    const timer = setTimeout(() => setTimedOut(true), 9000);
    return () => clearTimeout(timer);
  }, [loading, user]);

  if (loading || user === undefined) {
    if (timedOut) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
          <div className="max-w-sm w-full text-center rounded-2xl border border-border bg-card p-6 shadow-soft">
            <p className="font-semibold text-foreground mb-2">Das interne System lädt zu lange.</p>
            <p className="text-sm text-muted-foreground mb-5">Sie können die Seite verlassen oder die Anmeldung neu öffnen.</p>
            <div className="flex flex-col sm:flex-row gap-2 justify-center">
              <Button asChild variant="outline"><Link to="/">Zur Hauptseite</Link></Button>
              <Button asChild><Link to="/ticket-system/login">Login öffnen</Link></Button>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/ticket-system/login" replace />;
  // Affiliates have NO access to ticket system
  if (isAffiliate) return <Navigate to="/affiliate" replace />;
  return <>{children}</>;
};

export default ProtectedRoute;
